import { createSelector } from "reselect";
import { getMetadataFromMetricDetailsWithFilePath } from "./Metric/components/Wizard/MetricWizard.utils.js";
import { DEFAULT_METADATA } from "./Metric/components/CreateModal/CreateModal.constants.js";
const getWorkspaceIdFromState = (state) => {
  var _a, _b;
  return (_b = (_a = state.currentUserDetails.userAffinity) == null ? void 0 : _a.data) == null ? void 0 : _b.workspaceId;
};
const getWorkspaceIdSelector = createSelector([getWorkspaceIdFromState], (workspaceId) => workspaceId);
const getMetricMetadataSelector = (state) => {
  const metadata = state.maui.draft.metrics.metric_wizard.metadata;
  const metric_details = state.maui.draft.metrics.metric_wizard.metric_details.data;
  return !!metadata ? metadata : !!metric_details ? getMetadataFromMetricDetailsWithFilePath(state.maui.draft.metrics.metric_wizard.metric_details.data) : DEFAULT_METADATA;
};
const getComputationFilePathOptions = (state) => {
  var _a;
  const computationFilePaths = (_a = state.maui.draft.computation_file_paths.data) != null ? _a : [];
  return computationFilePaths.filter((m) => !m.match(/\.autogen\.xml$/g));
};
const getCustomColumns = (state) => {
  return state.maui.draft.columns.list;
};
const getRawColumns = (state) => {
  return state.maui.draft.raw_columns;
};
const getAggregationLevels = (state) => {
  return state.maui.draft.aggregation_levels;
};
export {
  getAggregationLevels,
  getComputationFilePathOptions,
  getCustomColumns,
  getMetricMetadataSelector,
  getRawColumns,
  getWorkspaceIdFromState,
  getWorkspaceIdSelector
};
//# sourceMappingURL=Maui.selectors.js.map
